/**
 * Created by ren on 02/06/2017.
 */
import { defineMessages } from 'react-intl';
import * as CustomTabTypes from '../../constants/constant_custom_tab_types';

export default defineMessages({
  //Start of Register
  default_on_account_to_zero: {
    id: 'preference.setting.default_on_account_to_zero.title',
    defaultMessage: 'Defaults on-account transactions to zero',
    key: 'default_on_account_to_zero',
    type: 'Boolean',
    label: 'Defaults on-account transactions to zero',
    category: 'Register',
    account: true,
    subsidiary: true,
  },

  allow_payment_reversal: {
    id: 'preference.setting.allow_payment_reversal.title',
    defaultMessage: 'Allow payment reversal',
    key: 'allow_payment_reversal',
    type: 'Boolean',
    label: 'Allow payment reversal',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  increase_cart_quantity: {
    id: 'preference.setting.increase_cart_quantity.title',
    defaultMessage: 'Increase cart quantity',
    key: 'increase_cart_quantity',
    type: 'Boolean',
    label: 'Increase cart quantity',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  //Start of Cart
  non_validated_reason_code_required: {
    id: 'preference.setting.non_validated_reason_code_required.title',
    defaultMessage: 'Non validated reason code required',
    key: 'non_validated_reason_code_required',
    type: 'Boolean',
    label: 'Non validated reason code required',
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  enable_deposit: {
    id: 'preference.setting.enable_deposit.title',
    defaultMessage: 'Enable deposit transaction type',
    key: 'enable_deposit',
    type: 'Boolean',
    label: 'Enable deposit transaction type',
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  enable_ereceipt: {
    id: 'preference.setting.enable_ereceipt.title',
    defaultMessage: 'Enable eReceipt',
    key: 'enable_ereceipt',
    type: 'Boolean',
    label: 'Enable eReceipt',
    category: 'Receipt Printing',
    location: true,
    account: true,
    subsidiary: true,
  },
  enable_layby: {
    id: 'preference.setting.enable_layby.title',
    defaultMessage: 'Enable layby transaction type',
    key: 'enable_layby',
    type: 'Boolean',
    label: 'Enable layby transaction type',
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  enable_onaccount: {
    id: 'preference.setting.enable_onaccount.title',
    defaultMessage: 'Enable on-account transaction type',
    key: 'enable_onaccount',
    type: 'Boolean',
    label: 'Enable on-account transaction type',
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  enable_preorder: {
    id: 'preference.setting.enable_preorder.title',
    defaultMessage: 'Enable pre-order transaction type',
    key: 'enable_preorder',
    type: 'Boolean',
    label: 'Enable pre-order transaction type',
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  enable_quote: {
    id: 'preference.setting.enable_quote.title',
    defaultMessage: 'Enable quote transaction type',
    key: 'enable_quote',
    type: 'Boolean',
    label: 'Enable quote transaction type',
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  enable_reserved: {
    id: 'preference.setting.enable_reserved.title',
    defaultMessage: 'Enable reserved transaction type',
    key: 'enable_reserved',
    type: 'Boolean',
    label: 'Enable reserved transaction type',
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  void_transaction_reason_code_required: {
    id: 'preference.setting.void_transaction_reason_code_required.title',
    defaultMessage: 'Void transaction reason code required',
    key: 'void_transaction_reason_code_required',
    type: 'Boolean',
    label: 'Void transaction reason code required',
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  void_transaction_item_reason_code_required: {
    id: 'preference.setting.void_transaction_item_reason_code_required.title',
    defaultMessage: 'Void transaction item reason code required',
    key: 'void_transaction_item_reason_code_required',
    type: 'Boolean',
    label: 'Void transaction item reason code required',
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  post_void_transaction_reason_code_required: {
    id: 'preference.setting.post_void_transaction_reason_code_required.title',
    defaultMessage: 'Post void transaction reason code required',
    key: 'post_void_transaction_reason_code_required',
    type: 'Boolean',
    label: 'Post void transaction reason code required',
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  post_void_transaction_item_reason_code_required: {
    id: 'preference.setting.post_void_transaction_item_reason_code_required.title',
    defaultMessage: 'Post void transaction item reason code required',
    key: 'post_void_transaction_item_reason_code_required',
    type: 'Boolean',
    label: 'Post void transaction item reason code required',
    category: 'Register',
    account: true,
    subsidiary: true,
  },

  //Start of Discount
  discount_reason_code_required: {
    id: 'preference.setting.discount_reason_code_required.title',
    defaultMessage: 'Discount reason code required',
    key: 'discount_reason_code_required',
    type: 'Boolean',
    label: 'Discount reason code required',
    category: 'Register',
    account: true,
    subsidiary: true,
  },

  //Start of Entity
  legal_age: {
    id: 'preference.setting.legal_age.title',
    defaultMessage: 'Legal age',
    key: 'legal_age',
    type: 'Numeric',
    value: 18,
    label: 'Legal age',
    category: 'System Settings',
    account: true,
    subsidiary: true,
  },
  entity_first_last_name_required: {
    id: 'preference.setting.entity_first_last_name_required.title',
    defaultMessage: 'Entity first name and last name required',
    key: 'entity_first_last_name_required',
    type: 'Boolean',
    label: 'Entity first name and last name required',
    category: 'System Settings',
    account: true,
  },
  enable_employee_as_customer: {
    id: 'preference.setting.enable_employee_as_customer.title',
    defaultMessage: 'Enable employee as customer',
    key: 'enable_employee_as_customer',
    type: 'Boolean',
    label: 'Enable employee as customer',
    category: 'System Settings',
    account: true,
  },
  enable_supplier_as_customer: {
    id: 'preference.setting.enable_supplier_as_customer.title',
    defaultMessage: 'Enable supplier as customer',
    key: 'enable_supplier_as_customer',
    type: 'Boolean',
    label: 'Enable supplier as customer',
    category: 'Register',
    account: true,
  },
  default_price_level: {
    id: 'preference.setting.default_price_level.title',
    defaultMessage: 'Default price level',
    key: 'default_price_level',
    type: 'Object',
    label: 'Default price level',
    category: 'System Settings',
    list: 'price_level',
    account: true,
    subsidiary: true,
  },

  //Start of Inactivity
  inactivity_idle_threshold: {
    id: 'preference.setting.inactivity_idle_threshold.title',
    defaultMessage: 'Inactivity Idle Threshold (Seconds)',
    key: 'inactivity_idle_threshold',
    type: 'Numeric',
    value: 300,
    label: 'Inactivity Idle Threshold (Seconds)',
    category: 'System Settings',
    account: true,
    subsidiary: true,
    location: true,
  },
  inactivity_logout_trigger: {
    id: 'preference.setting.inactivity_logout_trigger.title',
    defaultMessage: 'Inactivity Logout Trigger (Seconds)',
    key: 'inactivity_logout_trigger',
    type: 'Numeric',
    value: 1800,
    label: 'Inactivity Logout Trigger (Seconds)',
    category: 'System Settings',
    account: true,
    subsidiary: true,
    location: true,
  },
  pos_inactivity_idle_threshold: {
    id: 'preference.setting.pos_inactivity_idle_threshold.title',
    defaultMessage: 'POS Inactivity Idle Threshold (Seconds)',
    key: 'pos_inactivity_idle_threshold',
    type: 'Numeric',
    value: 1500,
    label: 'POS Inactivity Idle Threshold (Seconds)',
    category: 'System Settings',
    location: true,
    account: true,
    subsidiary: true,
  },
  pos_inactivity_logout_trigger: {
    id: 'preference.setting.pos_inactivity_logout_trigger.title',
    defaultMessage: 'POS Inactivity Logout Trigger (Seconds)',
    key: 'pos_inactivity_logout_trigger',
    type: 'Numeric',
    value: 1800,
    label: 'POS Inactivity Logout Trigger (Seconds)',
    category: 'System Settings',
    location: true,
    account: true,
    subsidiary: true,
  },

  //Start of Inventory
  include_backorder: {
    id: 'preference.setting.include_backorder.title',
    defaultMessage: 'Include back order for on-hand calculations',
    key: 'include_backorder',
    type: 'Boolean',
    label: 'Include back order for on-hand calculations',
    category: 'Item Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  //Start of Inventory transfer
  auto_receipt: {
    id: 'preference.setting.auto_receipt.title',
    defaultMessage: 'Transfer: Auto receipt',
    key: 'auto_receipt',
    type: 'Boolean',
    label: 'Transfer: Auto receipt',
    // category: "Inventory Transfer",
    category: 'Item Management',
    account: true,
    subsidiary: true,
    location: true,
  },
  auto_receipt_hours: {
    id: 'preference.setting.auto_receipt_hours.title',
    defaultMessage: 'Transfer: Auto receipt hours',
    key: 'auto_receipt_hours',
    type: 'Numeric',
    value: 1,
    label: 'Transfer: Auto receipt hours',
    // category: "Inventory Transfer",
    category: 'Item Management',
    account: true,
    subsidiary: true,
    location: true,
  },
  use_status_pick: {
    id: 'preference.setting.use_status_pick.title',
    defaultMessage: 'Transfer: Use status pick',
    key: 'use_status_pick',
    type: 'Boolean',
    label: 'Transfer: Use status pick',
    // category: "Inventory Transfer",
    category: 'Item Management',
    account: true,
    subsidiary: true,
    location: true,
  },
  use_status_pack: {
    id: 'preference.setting.use_status_pack.title',
    defaultMessage: 'Transfer: Use status pack',
    key: 'use_status_pack',
    type: 'Boolean',
    label: 'Transfer: Use status pack',
    // category: "Inventory Transfer",
    category: 'Item Management',
    account: true,
    subsidiary: true,
    location: true,
  },
  use_status_ship: {
    id: 'preference.setting.use_status_ship.title',
    defaultMessage: 'Transfer: Use status ship',
    key: 'use_status_ship',
    type: 'Boolean',
    label: 'Transfer: Use status ship',
    // category: "Inventory Transfer",
    category: 'Item Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  //Start of Item Management
  restrict_price_book_to_currency: {
    id: 'preference.setting.restrict_price_book_to_currency.title',
    defaultMessage: 'Restrict price book list based on currency',
    key: 'restrict_price_book_to_currency',
    type: 'Boolean',
    label: 'Restrict price book list based on currency',
    category: 'Item Management',
    account: true,
    subsidiary: true,
  },

  default_new_item_location_from_default: {
    id: 'preference.setting.default_new_item_location_from_default.title',
    defaultMessage: 'Set new item location details from default',
    key: 'default_new_item_location_from_default',
    type: 'Boolean',
    label: 'Set new item location details from default',
    category: 'Item Management',
    account: true,
    subsidiary: true,
  },

  enable_item_part_quantity: {
    id: 'preference.setting.enable_item_part_quantity.title',
    defaultMessage: 'Enable item part quantity',
    key: 'enable_item_part_quantity',
    type: 'Boolean',
    label: 'Enable item part quantity',
    category: 'Item Management',
    account: true,
  },

  //Start of Pricebook
  allow_current_price_book_update: {
    id: 'preference.setting.allow_current_price_book_update.title',
    defaultMessage: 'Allow current price book update',
    key: 'allow_current_price_book_update',
    type: 'Boolean',
    label: 'Allow current price book update',
    category: 'Item Management',
    account: true,
    subsidiary: true,
  },
  //Start of Promotion
  apply_best_promotion: {
    id: 'preference.setting.apply_best_promotion.title',
    defaultMessage: 'Apply best promotion',
    key: 'apply_best_promotion',
    type: 'Boolean',
    label: 'Apply best promotion',
    category: 'Promotion',
    account: true,
    subsidiary: true,
  },
  allow_stacking_with_transaction_promo: {
    id: 'preference.setting.allow_stacking_with_transaction_promo.title',
    defaultMessage: 'Allow stacking with transaction promotions',
    key: 'allow_stacking_with_transaction_promo',
    type: 'Boolean',
    label: 'Allow stacking with transaction promotions',
    category: 'Promotion',
    account: true,
    subsidiary: true,
  },
  allow_promo_discount_stacking: {
    id: 'preference.setting.allow_promo_discount_stacking.title',
    defaultMessage: 'Allow promo discount stacking',
    key: 'allow_promo_discount_stacking',
    type: 'Boolean',
    label: 'Allow promo discount stacking',
    category: 'Promotion',
    account: true,
    subsidiary: true,
    location: true,
  },
  allow_promo_coupon_stacking: {
    id: 'preference.setting.allow_promo_coupon_stacking.title',
    defaultMessage: 'Allow promo coupon stacking',
    key: 'allow_promo_coupon_stacking',
    type: 'Boolean',
    label: 'Allow promo coupon stacking',
    category: 'Promotion',
    account: true,
    subsidiary: true,
    location: true,
  },

  //Start of Receipt Printing
  integrated_payment_gateway_printing: {
    id: 'preference.setting.integrated_payment_gateway_printing.title',
    defaultMessage: 'Integrated payment gateway printing',
    key: 'integrated_payment_gateway_printing',
    type: 'Boolean',
    label: 'Integrated payment gateway printing',
    category: 'Receipt Printing',
    account: true,
    subsidiary: true,
    location: true,
  },
  print_payment_gateway_customer_receipt: {
    id: 'preference.setting.print_payment_gateway_customer_receipt.title',
    defaultMessage: 'Print payment gateway customer receipt',
    key: 'print_payment_gateway_customer_receipt',
    type: 'Boolean',
    label: 'Print payment gateway customer receipt',
    category: 'Receipt Printing',
    account: true,
    subsidiary: true,
    location: true,
  },
  print_payment_gateway_merchant_receipt: {
    id: 'preference.setting.print_payment_gateway_merchant_receipt.title',
    defaultMessage: 'Print payment gateway merchant receipt',
    key: 'print_payment_gateway_merchant_receipt',
    type: 'Boolean',
    label: 'Print payment gateway merchant receipt',
    category: 'Receipt Printing',
    account: true,
    subsidiary: true,
    location: true,
  },
  signature_from_payment_gateway: {
    id: 'preference.setting.signature_from_payment_gateway.title',
    defaultMessage: 'Signature from payment gateway',
    key: 'signature_from_payment_gateway',
    type: 'Boolean',
    label: 'Signature from payment gateway',
    category: 'Receipt Printing',
    account: true,
    subsidiary: true,
    location: true,
  },
  suppress_merchant_password_payment_gateway: {
    id: 'preference.setting.suppress_merchant_password_payment_gateway.title',
    defaultMessage: 'Suppress payment gateway merchant password ',
    key: 'suppress_merchant_password_payment_gateway',
    type: 'Boolean',
    label: 'Suppress payment gateway merchant password',
    category: 'Receipt Printing',
    account: true,
    subsidiary: true,
    location: true,
  },

  //Start of Register
  allow_cross_subsidiary_administration: {
    id: 'preference.setting.allow_cross_subsidiary_administration.title',
    defaultMessage: 'Allow cross subsidiary administration',
    key: 'allow_cross_subsidiary_administration',
    type: 'Boolean',
    label: 'Allow cross subsidiary administration',
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  allow_fulfillment_of_unpaid_layby: {
    id: 'preference.setting.allow_fulfillment_of_unpaid_layby.title',
    defaultMessage: 'Allow fulfillment of unpaid layby',
    key: 'allow_fulfillment_of_unpaid_layby',
    type: 'Boolean',
    label: 'Allow fulfillment of unpaid layby',
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  allow_fulfillment_of_unpaid_deposit: {
    id: 'preference.setting.allow_fulfillment_of_unpaid_deposit.title',
    defaultMessage: 'Allow fulfillment of unpaid deposit',
    key: 'allow_fulfillment_of_unpaid_deposit',
    type: 'Boolean',
    label: 'Allow fulfillment of unpaid deposit',
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  allow_sale_done_with_balance: {
    id: 'preference.setting.allow_sale_done_with_balance.title',
    defaultMessage: 'Allow sale done with balance',
    key: 'allow_sale_done_with_balance',
    type: 'Boolean',
    label: 'Allow sale done with balance',
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  enable_pickup_from_alternate_subsidiary: {
    id: 'preference.setting.enable_pickup_from_alternate_subsidiary.title',
    defaultMessage: 'Allow pickup from alternate subsidiary',
    key: 'enable_pickup_from_alternate_subsidiary',
    type: 'Boolean',
    label: 'Allow pickup from alternate subsidiary',
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  authorise_zero_dollar_item: {
    id: 'preference.setting.authorise_zero_dollar_item.title',
    defaultMessage: 'Allow $0 sale',
    key: 'authorise_zero_dollar_item',
    type: 'Boolean',
    label: 'Allow $0 sale',
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  enable_editing_of_layby: {
    id: 'preference.setting.enable_editing_of_layby.title',
    defaultMessage: 'Allow editing of layby',
    key: 'enable_editing_of_layby',
    type: 'Boolean',
    label: 'Allow editing of layby',
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  enable_editing_of_deposit: {
    id: 'preference.setting.enable_editing_of_deposit.title',
    defaultMessage: 'Allow editing of deposit',
    key: 'enable_editing_of_deposit',
    type: 'Boolean',
    label: 'Allow editing of deposit',
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  barcode_min_char_threshold: {
    id: 'preference.setting.barcode_min_char_threshold.title',
    defaultMessage: 'Barcode minimum character threshold',
    key: 'barcode_min_char_threshold',
    type: 'Numeric',
    value: 8,
    label: 'Barcode Minimum Character Threshold',
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  barcode_time_threshold: {
    id: 'preference.setting.barcode_time_threshold.title',
    defaultMessage: 'Barcode Time Threshold (Milliseconds)',
    key: 'barcode_time_threshold',
    type: 'Numeric',
    value: 300,
    label: 'Barcode Time Threshold (Milliseconds)',
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  apply_quantity_break_to_transaction: {
    id: 'preference.setting.apply_quantity_break_to_transaction.title',
    defaultMessage:
      "Apply the quantity break based on the item's quantity in cart",
    key: 'apply_quantity_break_to_transaction',
    type: 'Boolean',
    label: "Apply the quantity break based on the item's quantity in cart",
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  display_matrix_parent_items: {
    id: 'preference.setting.display_matrix_parent_items.title',
    defaultMessage: 'Display matrix parent items',
    key: 'display_matrix_parent_items',
    type: 'Boolean',
    label: 'Display matrix parent items',
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  display_matrix_child_items: {
    id: 'preference.setting.display_matrix_child_items.title',
    defaultMessage: 'Display matrix child items',
    key: 'display_matrix_child_items',
    type: 'Boolean',
    label: 'Display matrix child items',
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  use_actual_sale_price: {
    id: 'preference.setting.use_actual_sale_price.title',
    defaultMessage: 'Return - Use actual sales price',
    key: 'use_actual_sale_price',
    type: 'Boolean',
    label: 'Return - Use actual sales price',
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  item_drilldown_only_show_locations_with_inventory: {
    id: 'preference.setting.item_drilldown_only_show_locations_with_inventory.title',
    defaultMessage: 'Item drilldown - Only show locations with inventory',
    key: 'item_drilldown_only_show_locations_with_inventory',
    type: 'Boolean',
    label: 'Item drilldown - Only show locations with inventory',
    category: 'Register',
    account: true,
    subsidiary: true,
  },
  tax_line_round: {
    id: 'preference.setting.tax_line_round.title',
    defaultMessage: 'Return - Tax line round',
    key: 'tax_line_round',
    type: 'Object',
    label: 'Return - Tax line round',
    category: 'Register',
    list: 'cash_rounding',
    account: true,
    subsidiary: true,
  },

  pos_hotkey_template: {
    id: 'preference.setting.pos_hotkey_template.title',
    defaultMessage: 'POS hotkey template',
    key: 'pos_hotkey_template',
    type: 'Object',
    label: 'POS hotkey template',
    category: 'Register',
    list: 'hotkey_template',
    account: true,
    subsidiary: true,
    location: true,
    doc_display: 'reference_id',
  },

  enable_multi_currency: {
    id: 'preference.setting.enable_multi_currency.title',
    defaultMessage: 'Enable multi currency',
    key: 'enable_multi_currency',
    type: 'Boolean',
    label: 'Enable multi currency',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  enable_group_price: {
    id: 'preference.setting.enable_group_price.title',
    defaultMessage: 'Enable group pricing',
    key: 'enable_group_price',
    type: 'Boolean',
    label: 'Enable group pricing',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  hotkey_include_alternate_uom: {
    id: 'preference.setting.hotkey_include_alternate_uom.title',
    defaultMessage: 'Hotkey include alternate unit of measure',
    key: 'hotkey_include_alternate_uom',
    type: 'Boolean',
    label: 'Hotkey include alternate unit of measure',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  search_results_include_alternate_uom: {
    id: 'preference.setting.search_results_include_alternate_uom.title',
    defaultMessage: 'Search result include alternate unit of measure',
    key: 'search_results_include_alternate_uom',
    type: 'Boolean',
    label: 'Search result include alternate unit of measure',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  enable_search_lookup: {
    id: 'preference.setting.enable_search_lookup.title',
    defaultMessage: 'Enable look-up',
    key: 'enable_search_lookup',
    type: 'Boolean',
    label: 'Enable look-up',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  group_price_reason_code: {
    id: 'preference.setting.group_price_reason_code.title',
    defaultMessage: 'Group price reason code',
    key: 'group_price_reason_code',
    type: 'Object',
    label: 'Group price reason code',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
    list: 'reason_code',
    doc_display: 'name',
  },

  enable_return_to_shelf: {
    id: 'preference.setting.enable_return_to_shelf.title',
    defaultMessage: 'Enable return to shelf',
    key: 'enable_return_to_shelf',
    type: 'Boolean',
    label: 'Enable return to shelf',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  // Report date range preference
  customer_drilldown_transaction_history_days: {
    id: 'preference.setting.customer_drilldown_transaction_history_days.title',
    defaultMessage:
      'Customer drilldown transaction history days (today - days)',
    key: 'customer_drilldown_transaction_history_days',
    type: 'Numeric',
    value: 365,
    label: 'Customer Drilldown Transaction History Days (today - days)',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
    validation: 'currency',
  },

  exchange_rate_reporting_period: {
    id: 'preference.setting.exchange_rate_reporting_period.title',
    defaultMessage: 'Reporting exchange rate period',
    key: 'exchange_rate_reporting_period',
    type: 'Object',
    defined_list: [
      {
        id: 'dt:reporting_period:daily',
        name: 'Daily',
      },
      {
        id: 'dt:reporting_period:weekly',
        name: 'Weekly',
      },
      {
        id: 'dt:reporting_period:monthly',
        name: 'Monthly',
      },
      {
        id: 'dt:reporting_period:quarterly',
        name: 'Quarterly',
      },
      {
        id: 'dt:reporting_period:half_yearly',
        name: 'Half Yearly',
      },
      {
        id: 'dt:reporting_period:yearly',
        name: 'Yearly',
      },
    ],
    label: 'Reporting exchange rate period',
    category: 'System Settings',
    // list: "reporting_period",
    account: true,
  },

  consolidated_reporting_currency: {
    id: 'preference.setting.consolidated_reporting_currency.title',
    defaultMessage: 'Consolidated reporting currency',
    key: 'consolidated_reporting_currency',
    type: 'Object',
    label: 'Consolidated reporting currency',
    category: 'System Settings',
    list: 'currency',
    account: true,
  },

  use_consolidated_reporting_currency: {
    id: 'preference.setting.use_consolidated_reporting_currency.title',
    defaultMessage: 'Use consolidated reporting currency',
    key: 'use_consolidated_reporting_currency',
    type: 'Boolean',
    label: 'Use consolidated reporting currency',
    category: 'System Settings',
    account: true,
  },

  //Start of Search
  search_default_rows_count_list: {
    id: 'preference.setting.search_default_rows_count_list.title',
    defaultMessage: 'Number of rows in list',
    key: 'search_default_rows_count_list',
    type: 'Numeric',
    value: 10,
    label: 'Number of rows in list',
    category: 'System Settings',
    account: true,
    subsidiary: true,
    location: true,
  },
  audit_logs_rows_count_list: {
    id: 'preference.setting.audit_logs_rows_count_list.title',
    defaultMessage: 'Number of audit log rows in list',
    key: 'audit_logs_rows_count_list',
    type: 'Numeric',
    value: 5,
    label: 'Number of audit log rows in list',
    category: 'System Settings',
    account: true,
    subsidiary: true,
    location: true,
  },

  //Start of Report
  time_format: {
    id: 'preference.setting.time_format.title',
    defaultMessage: 'Time format',
    key: 'time_format',
    type: 'Object',
    defined_list: [
      {
        id: 'HH:mm:ss',
        name: 'HH:mm:ss',
      },
      {
        id: 'HH:mm',
        name: 'HH:mm',
      },
      {
        id: 'HH:mm:ss:sss',
        name: 'HH:mm:ss:sss',
      },
    ],
    label: 'Time format',
    category: 'System Settings',
    account: true,
    subsidiary: true,
    location: false,
  },
  date_format: {
    id: 'preference.setting.date_format.title',
    defaultMessage: 'Date format',
    key: 'date_format',
    type: 'Object',
    defined_list: [
      {
        id: 'DD/MM/YYYY',
        name: 'DD/MM/YYYY',
      },
      {
        id: 'MM/DD/YYYY',
        name: 'MM/DD/YYYY',
      },
      {
        id: 'YYYY/MM/DD',
        name: 'YYYY/MM/DD',
      },
    ],
    label: 'Date format',
    category: 'System Settings',
    account: true,
    subsidiary: true,
    location: false,
  },
  date_time_format: {
    id: 'preference.setting.date_time_format.title',
    defaultMessage: 'Date time format',
    key: 'date_time_format',
    type: 'Object',
    defined_list: [
      {
        id: 'DD/MM/YYYY HH:mm',
        name: 'DD/MM/YYYY HH:mm',
      },
      {
        id: 'DD/MM/YYYY HH:mm:ss',
        name: 'DD/MM/YYYY HH:mm:ss',
      },
      {
        id: 'DD/MM/YYYY HH:mm:ss:sss',
        name: 'DD/MM/YYYY HH:mm:ss:sss',
      },
      {
        id: 'MM/DD/YYYY HH:mm',
        name: 'MM/DD/YYYY HH:mm',
      },
      {
        id: 'MM/DD/YYYY HH:mm:ss',
        name: 'MM/DD/YYYY HH:mm:ss',
      },
      {
        id: 'MM/DD/YYYY HH:mm:ss:sss',
        name: 'MM/DD/YYYY HH:mm:ss:sss',
      },
      {
        id: 'YYYY/MM/DD HH:mm',
        name: 'YYYY/MM/DD HH:mm',
      },
      {
        id: 'YYYY/MM/DD HH:mm:ss',
        name: 'YYYY/MM/DD HH:mm:ss',
      },
      {
        id: 'YYYY/MM/DD HH:mm:ss:sss',
        name: 'YYYY/MM/DD HH:mm:ss:sss',
      },
    ],
    label: 'Date time format',
    category: 'System Settings',
    account: true,
    subsidiary: true,
    location: false,
  },

  pos_internet_response_threshold: {
    id: 'preference.setting.pos_internet_response_threshold.title',
    defaultMessage: 'POS internet availability threshold',
    key: 'pos_internet_response_threshold',
    type: 'Numeric',
    value: 10000,
    label: 'POS Internet Availability Threshold',
    category: 'System Settings',
    account: true,
    subsidiary: true,
    location: true,
  },

  pos_slow_internet_check_delay: {
    id: 'preference.setting.pos_slow_internet_check_delay.title',
    defaultMessage: 'POS internet check delay',
    key: 'pos_slow_internet_check_delay',
    type: 'Numeric',
    value: 6000,
    label: 'POS Internet Check Delay',
    category: 'System Settings',
    account: true,
    subsidiary: true,
    location: true,
  },

  default_barcode_average_time_per_character: {
    id: 'preference.setting.default_barcode_average_time_per_character.title',
    defaultMessage: 'Default barcode average time per character',
    key: 'default_barcode_average_time_per_character',
    type: 'Numeric',
    value: 40,
    label: 'Default barcode average time per character',
    category: 'System Settings',
    account: true,
    subsidiary: true,
  },
  default_barcode_minimum_barcode_length: {
    id: 'preference.setting.default_barcode_minimum_barcode_length.title',
    defaultMessage: 'Default barcode minimum barcode length',
    key: 'default_barcode_minimum_barcode_length',
    type: 'Numeric',
    value: 6,
    label: 'Default barcode minimum barcode length',
    category: 'System Settings',
    account: true,
    subsidiary: true,
  },

  default_barcode_time_before_scan_test: {
    id: 'preference.setting.default_barcode_time_before_scan_test.title',
    defaultMessage: 'Default barcode time before scan test',
    key: 'default_barcode_time_before_scan_test',
    type: 'Numeric',
    value: 200,
    label: 'Default barcode time before scan test',
    category: 'System Settings',
    account: true,
    subsidiary: true,
  },

  //Start of Tax
  tax_inclusive: {
    id: 'preference.setting.tax_inclusive.title',
    defaultMessage: 'Tax inclusive inline',
    key: 'tax_inclusive',
    type: 'Boolean',
    label: 'Tax inclusive inline',
    // category: "Tax",
    category: 'Register',
    account: true,
    subsidiary: true,
  },

  //Start of Till Management
  default_float: {
    id: 'preference.setting.default_float.title',
    defaultMessage: 'Float default',
    key: 'default_float',
    type: 'Numeric',
    value: 0,
    label: 'Float default',
    category: 'Till Management',
    validation: 'currency',
    account: true,
    subsidiary: true,
    location: true,
  },
  count_denominations: {
    id: 'preference.setting.count_denominations.title',
    defaultMessage: 'Counting by denominations',
    key: 'count_denominations',
    type: 'Boolean',
    label: 'Counting by denominations',
    category: 'Till Management',
    account: true,
    subsidiary: true,
    location: true,
  },
  open_employee_only: {
    id: 'preference.setting.open_employee_only.title',
    defaultMessage: 'Restrict to an employee',
    key: 'open_employee_only',
    type: 'Boolean',
    label: 'Restrict to an employee',
    category: 'Till Management',
    account: true,
    subsidiary: true,
    location: true,
  },
  till_shifts: {
    id: 'preference.setting.till_shifts.title',
    defaultMessage: 'Till identified by shifts',
    key: 'till_shifts',
    type: 'Boolean',
    label: 'Till identified by shifts',
    category: 'Till Management',
    account: true,
    subsidiary: true,
    location: true,
  },
  allow_till_correction: {
    id: 'preference.setting.allow_till_correction.title',
    defaultMessage: 'Allow till count corrections',
    key: 'allow_till_correction',
    type: 'Boolean',
    label: 'Allow till count corrections',
    category: 'Till Management',
    account: true,
    subsidiary: true,
    location: true,
  },
  allowable_currency: {
    id: 'preference.setting.allowable_currency.title',
    defaultMessage: 'Multi-currency',
    key: 'allowable_currency',
    type: 'Boolean',
    label: 'Multi-currency',
    category: 'Till Management',
    account: true,
    subsidiary: true,
    location: true,
  },
  till_summary_template: {
    id: 'preference.setting.till_summary_template.title',
    defaultMessage: 'Till summary template',
    key: 'till_summary_template',
    type: 'Object',
    label: 'Till summary template',
    category: 'Till Management',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:till'],
      template_type: [
        'dt:template_type:thermal_print',
        'dt:template_type:print',
      ],
      output_type: [
        'dt:template_output_type:xml',
        'dt:template_output_type:pdf',
      ],
      template_till_transaction_type: ['till_summary'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  chit_template: {
    id: 'preference.setting.chit_template.title',
    defaultMessage: 'Chit template',
    key: 'chit_template',
    type: 'Object',
    label: 'Chit template',
    category: 'Till Management',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:till'],
      template_type: [
        'dt:template_type:thermal_print',
        'dt:template_type:print',
      ],
      output_type: [
        'dt:template_output_type:xml',
        'dt:template_output_type:pdf',
      ],
      template_till_transaction_type: ['chit'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  display_store_payments: {
    id: 'preference.setting.display_store_payments.title',
    defaultMessage: 'Display store payments',
    key: 'display_store_payments',
    type: 'Boolean',
    label: 'Display store payments',
    category: 'Till Management',
    account: true,
    subsidiary: true,
    location: true,
  },
  till_reason_code_required: {
    id: 'preference.setting.till_reason_code_required.title',
    defaultMessage: 'Till reason code required',
    key: 'till_reason_code_required',
    type: 'Boolean',
    label: 'Till reason code required',
    category: 'Till Management',
    account: true,
    subsidiary: true,
    location: true,
  },
  alert_till_eod_greater_than_float: {
    id: 'preference.setting.alert_till_eod_greater_than_float.title',
    defaultMessage: 'Alert Till EOD greater than default float',
    key: 'alert_till_eod_greater_than_float',
    type: 'Boolean',
    label: 'Alert Till EOD greater than default float',
    category: 'Till Management',
    account: true,
    subsidiary: true,
    location: true,
  },
  alert_till_eod_less_than_float: {
    id: 'preference.setting.alert_till_eod_less_than_float.title',
    defaultMessage: 'Alert Till EOD less than default float',
    key: 'alert_till_eod_less_than_float',
    type: 'Boolean',
    label: 'Alert Till EOD less than default float',
    category: 'Till Management',
    account: true,
    subsidiary: true,
    location: true,
  },
  enable_chit_printing: {
    id: 'preference.setting.enable_chit_printing.title',
    defaultMessage: 'Enable Chit printing',
    key: 'enable_chit_printing',
    type: 'Boolean',
    label: 'Enable Chit printing',
    category: 'Till Management',
    account: true,
    subsidiary: true,
    location: true,
  },
  bank_drop_comment_required: {
    id: 'preference.setting.bank_drop_comment_required.title',
    defaultMessage: 'Bank drop comment required',
    key: 'bank_drop_comment_required',
    type: 'Boolean',
    label: 'Bank drop comment required',
    category: 'Till Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  // Email templates
  email_body_template_deposit: {
    id: 'preference.setting.email_body_template_deposit.title',
    defaultMessage: 'Email body template (Deposit)',
    key: 'email_body_template_deposit',
    type: 'Object',
    label: 'Email body template (Deposit)',
    category: 'Email Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: ['dt:template_type:email'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  email_body_template_layby: {
    id: 'preference.setting.email_body_template_layby.title',
    defaultMessage: 'Email body template (Layby)',
    key: 'email_body_template_layby',
    type: 'Object',
    label: 'Email body template (Layby)',
    category: 'Email Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: ['dt:template_type:email'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  email_body_template_onaccount: {
    id: 'preference.setting.email_body_template_onaccount.title',
    defaultMessage: 'Email body template (on account)',
    key: 'email_body_template_onaccount',
    type: 'Object',
    label: 'Email body template (On Account)',
    category: 'Email Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: ['dt:template_type:email'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  email_body_template_preorder: {
    id: 'preference.setting.email_body_template_preorder.title',
    defaultMessage: 'Email body template (Pre-order)',
    key: 'email_body_template_preorder',
    type: 'Object',
    label: 'Email body template (Pre-order)',
    category: 'Email Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: ['dt:template_type:email'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  email_body_template_quote: {
    id: 'preference.setting.email_body_template_quote.title',
    defaultMessage: 'Email body template (Quote)',
    key: 'email_body_template_quote',
    type: 'Object',
    label: 'Email body template (Quote)',
    category: 'Email Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: ['dt:template_type:email'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  email_body_template_reserved: {
    id: 'preference.setting.email_body_template_reserved.title',
    defaultMessage: 'Email body template (Reserved)',
    key: 'email_body_template_reserved',
    type: 'Object',
    label: 'Email body template (Reserved)',
    category: 'Email Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: ['dt:template_type:email'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  email_body_template_sale: {
    id: 'preference.setting.email_body_template_sale.title',
    defaultMessage: 'Email body template (Sale)',
    key: 'email_body_template_sale',
    type: 'Object',
    label: 'Email body template (Sale)',
    category: 'Email Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: ['dt:template_type:email'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  email_body_template_pin: {
    id: 'preference.setting.email_body_template_pin.title',
    defaultMessage: 'Email body template (PIN)',
    key: 'email_body_template_pin',
    type: 'Object',
    label: 'Email body template (PIN)',
    category: 'Email Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:entity'],
      template_type: ['dt:template_type:email'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  email_body_template_sale_admin: {
    id: 'preference.setting.email_body_template_sale_admin.title',
    defaultMessage: 'Email body template (Sale - Admin)',
    key: 'email_body_template_sale_admin',
    type: 'Object',
    label: 'Email body template (Sale - Admin)',
    category: 'Email Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale:admin'],
      template_type: ['dt:template_type:email'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  email_body_template_search_record: {
    id: 'preference.setting.email_body_template_search_record.title',
    defaultMessage: 'Email body template (Search record)',
    key: 'email_body_template_search_record',
    type: 'Object',
    label: 'Email body template (Search record)',
    category: 'Email Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:search_record'],
      template_type: ['dt:template_type:email'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },

  //SMS Templates
  sms_template_pin: {
    id: 'preference.setting.sms_template_pin.title',
    defaultMessage: 'SMS template (PIN)',
    key: 'sms_template_pin',
    type: 'Object',
    label: 'SMS template (PIN)',
    category: 'SMS Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:entity'],
      template_type: ['dt:template_type:sms'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },

  //Email attachment templates
  email_attachment_template_deposit: {
    id: 'preference.setting.email_attachment_template_deposit.title',
    defaultMessage: 'Email attachment template (Deposit)',
    key: 'email_attachment_template_deposit',
    type: 'Object',
    label: 'Email attachment template (Deposit)',
    category: 'Email Attachment Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: ['dt:template_type:email_attachment'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  email_attachment_template_layby: {
    id: 'preference.setting.email_attachment_template_layby.title',
    defaultMessage: 'Email attachment template (Layby)',
    key: 'email_attachment_template_layby',
    type: 'Object',
    label: 'Email attachment template (Layby)',
    category: 'Email Attachment Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: ['dt:template_type:email_attachment'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  email_attachment_template_onaccount: {
    id: 'preference.setting.email_attachment_template_onaccount.title',
    defaultMessage: 'Email attachment template (On Account)',
    key: 'email_attachment_template_onaccount',
    type: 'Object',
    label: 'Email attachment template (On Account)',
    category: 'Email Attachment Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: ['dt:template_type:email_attachment'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  email_attachment_template_preorder: {
    id: 'preference.setting.email_attachment_template_preorder.title',
    defaultMessage: 'Email attachment template (Pre-order)',
    key: 'email_attachment_template_preorder',
    type: 'Object',
    label: 'Email attachment template (Pre-order)',
    category: 'Email Attachment Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: ['dt:template_type:email_attachment'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  email_attachment_template_quote: {
    id: 'preference.setting.email_attachment_template_quote.title',
    defaultMessage: 'Email attachment template (Quote)',
    key: 'email_attachment_template_quote',
    type: 'Object',
    label: 'Email attachment template (Quote)',
    category: 'Email Attachment Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: ['dt:template_type:email_attachment'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  email_attachment_template_reserved: {
    id: 'preference.setting.email_attachment_template_reserved.title',
    defaultMessage: 'Email attachment template (Reserved)',
    key: 'email_attachment_template_reserved',
    type: 'Object',
    label: 'Email attachment template (Reserved)',
    category: 'Email Attachment Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: ['dt:template_type:email_attachment'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  email_attachment_template_sale: {
    id: 'preference.setting.email_attachment_template_sale.title',
    defaultMessage: 'Email attachment template (Sale)',
    key: 'email_attachment_template_sale',
    type: 'Object',
    label: 'Email attachment template (Sale)',
    category: 'Email Attachment Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: ['dt:template_type:email_attachment'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  email_attachment_template_purchase_order: {
    id: 'preference.setting.email_attachment_template_purchase_order.title',
    defaultMessage: 'Email attachment template (Purchase order)',
    key: 'email_attachment_template_purchase_order',
    type: 'Object',
    label: 'Email attachment template (Purchase order)',
    category: 'Email Attachment Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:purchase'],
      template_type: ['dt:template_type:email_attachment'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  email_attachment_template_inventory_return: {
    id: 'preference.setting.email_attachment_template_inventory_return.title',
    defaultMessage: 'Email attachment template (Inventory return)',
    key: 'email_attachment_template_inventory_return',
    type: 'Object',
    label: 'Email attachment template (Inventory return)',
    category: 'Email Attachment Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:purchase'],
      template_type: ['dt:template_type:email_attachment'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  email_attachment_template_inventory_transfer: {
    id: 'preference.setting.email_attachment_template_inventory_transfer.title',
    defaultMessage: 'Email attachment template (Inventory transfer)',
    key: 'email_attachment_template_inventory_transfer',
    type: 'Object',
    label: 'Email attachment template (Inventory transfer)',
    category: 'Email Attachment Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:inventory'],
      template_type: ['dt:template_type:email_attachment'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  email_attachment_template_sale_admin: {
    id: 'preference.setting.email_attachment_template_sale_admin.title',
    defaultMessage: 'Email attachment template (Sale - Admin)',
    key: 'email_attachment_template_sale_admin',
    type: 'Object',
    label: 'Email attachment template (Sale - Admin)',
    category: 'Email Attachment Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale:admin'],
      template_type: ['dt:template_type:email_attachment'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },

  //Print template
  print_template_deposit: {
    id: 'preference.setting.print_template_deposit.title',
    defaultMessage: 'Deposit',
    key: 'print_template_deposit',
    type: 'Object',
    label: 'Deposit',
    category: 'Print Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: [
        'dt:template_type:print',
        'dt:template_type:thermal_print',
      ],
      output_type: [
        'dt:template_output_type:xml',
        'dt:template_output_type:pdf',
        'dt:template_output_type:text',
      ],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  print_template_layby: {
    id: 'preference.setting.print_template_layby.title',
    defaultMessage: 'Layby',
    key: 'print_template_layby',
    type: 'Object',
    label: 'Layby',
    category: 'Print Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: [
        'dt:template_type:print',
        'dt:template_type:thermal_print',
      ],
      output_type: [
        'dt:template_output_type:xml',
        'dt:template_output_type:pdf',
        'dt:template_output_type:text',
      ],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  print_template_onaccount: {
    id: 'preference.setting.print_template_onaccount.title',
    defaultMessage: 'On account',
    key: 'print_template_onaccount',
    type: 'Object',
    label: 'On account',
    category: 'Print Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: [
        'dt:template_type:print',
        'dt:template_type:thermal_print',
      ],
      output_type: [
        'dt:template_output_type:xml',
        'dt:template_output_type:pdf',
        'dt:template_output_type:text',
      ],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  print_template_preorder: {
    id: 'preference.setting.print_template_preorder.title',
    defaultMessage: 'Pre-order',
    key: 'print_template_preorder',
    type: 'Object',
    label: 'Pre-order',
    category: 'Print Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: [
        'dt:template_type:print',
        'dt:template_type:thermal_print',
      ],
      output_type: [
        'dt:template_output_type:xml',
        'dt:template_output_type:pdf',
        'dt:template_output_type:text',
      ],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  print_template_quote: {
    id: 'preference.setting.print_template_quote.title',
    defaultMessage: 'Quote',
    key: 'print_template_quote',
    type: 'Object',
    label: 'Quote',
    category: 'Print Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: [
        'dt:template_type:print',
        'dt:template_type:thermal_print',
      ],
      output_type: [
        'dt:template_output_type:xml',
        'dt:template_output_type:pdf',
        'dt:template_output_type:text',
      ],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  print_template_reserved: {
    id: 'preference.setting.print_template_reserved.title',
    defaultMessage: 'Reserved',
    key: 'print_template_reserved',
    type: 'Object',
    label: 'Reserved',
    category: 'Print Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: [
        'dt:template_type:print',
        'dt:template_type:thermal_print',
      ],
      output_type: [
        'dt:template_output_type:xml',
        'dt:template_output_type:pdf',
        'dt:template_output_type:text',
      ],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  print_template_sale: {
    id: 'preference.setting.print_template_sale.title',
    defaultMessage: 'Sale',
    key: 'print_template_sale',
    type: 'Object',
    label: 'Sale',
    category: 'Print Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: [
        'dt:template_type:print',
        'dt:template_type:thermal_print',
      ],
      output_type: [
        'dt:template_output_type:xml',
        'dt:template_output_type:pdf',
        'dt:template_output_type:text',
      ],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  print_template_sale_admin: {
    id: 'preference.setting.print_template_sale_admin.title',
    defaultMessage: 'Sale (Admin)',
    key: 'print_template_sale_admin',
    type: 'Object',
    label: 'Sale (Admin)',
    category: 'Print Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale:admin'],
      template_type: ['dt:template_type:print'],
      output_type: ['dt:template_output_type:pdf'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  print_template_sale_oms: {
    id: 'preference.setting.print_template_sale_oms.title',
    defaultMessage: 'Sale (OMS)',
    key: 'print_template_sale_oms',
    type: 'Object',
    label: 'Sale (OMS)',
    category: 'Print Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale:admin'],
      template_type: ['dt:template_type:print'],
      output_type: ['dt:template_output_type:pdf'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  print_template_purchase_order: {
    id: 'preference.setting.print_template_purchase_order.title',
    defaultMessage: 'Purchase order',
    key: 'print_template_purchase_order',
    type: 'Object',
    label: 'Purchase order',
    category: 'Print Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:purchase'],
      template_type: ['dt:template_type:print'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  print_template_inventory_return: {
    id: 'preference.setting.print_template_inventory_return.title',
    defaultMessage: 'Inventory return',
    key: 'print_template_inventory_return',
    type: 'Object',
    label: 'Inventory return',
    category: 'Print Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:purchase'],
      template_type: ['dt:template_type:print'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  print_template_inventory_transfer: {
    id: 'preference.setting.print_template_inventory_transfer.title',
    defaultMessage: 'Inventory transfer',
    key: 'print_template_inventory_transfer',
    type: 'Object',
    label: 'Inventory transfer',
    category: 'Print Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:inventory'],
      template_type: ['dt:template_type:print'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  print_template_service_print: {
    id: 'preference.setting.print_template_service_print.title',
    defaultMessage: 'Service Print',
    key: 'print_template_service_print',
    type: 'Object',
    label: 'Service Print',
    category: 'Print Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: ['dt:template_type:thermal_print'],
      output_type: ['dt:template_output_type:xml'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },
  print_template_ereceipt: {
    id: 'preference.setting.print_template_ereceipt.title',
    defaultMessage: 'eReceipt',
    key: 'print_template_ereceipt',
    type: 'Object',
    label: 'eReceipt',
    category: 'Print Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale:admin'],
      template_type: ['dt:template_type:print'],
      output_type: ['dt:template_output_type:pdf'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_packing_slip: {
    id: 'preference.setting.oms_packing_slip.title',
    defaultMessage: 'OMS Packing slip',
    key: 'oms_packing_slip',
    type: 'Object',
    label: 'OMS Pack Slip',
    category: 'Print Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:oms:order'],
      template_type: ['dt:template_type:pack'],
      output_type: ['dt:template_output_type:pdf'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_shipping_label: {
    id: 'preference.setting.oms_shipping_label.title',
    defaultMessage: 'OMS Shipping label',
    key: 'oms_shipping_label',
    type: 'Object',
    label: 'OMS Shipping label',
    category: 'Print Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:oms:order'],
      template_type: ['dt:template_type:label'],
      output_type: ['dt:template_output_type:pdf'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_pickup_store_label: {
    id: 'preference.setting.oms_pickup_store_label.title',
    defaultMessage: 'OMS Pick-up store label',
    key: 'oms_pickup_store_label',
    type: 'Object',
    label: 'OMS Pick-up store label',
    category: 'Print Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:oms:order'],
      template_type: ['dt:template_type:label'],
      output_type: ['dt:template_output_type:pdf'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_picking_list: {
    id: 'preference.setting.oms_picking_list.title',
    defaultMessage: 'OMS Picking list',
    key: 'oms_picking_list',
    type: 'Object',
    label: 'OMS Picking list',
    category: 'Print Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:oms:order'],
      template_type: ['dt:template_type:pick'],
      output_type: ['dt:template_output_type:pdf'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_pickup_label: {
    id: 'preference.setting.oms_picking_list.title',
    defaultMessage: 'OMS Pickup label',
    key: 'oms_pickup_label',
    type: 'Object',
    label: 'OMS Pickup label',
    category: 'Print Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:oms:order'],
      template_type: ['dt:template_type:pickup'],
      output_type: ['dt:template_output_type:pdf'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },

  pos_viewport_size: {
    id: 'preference.setting.pos_viewport_size.title',
    defaultMessage: 'POS font size',
    key: 'pos_viewport_size',
    type: 'Object',
    defined_list: [
      {
        id: 'Regular',
        name: 'Regular',
      },
      {
        id: 'Medium',
        name: 'Medium',
      },
      {
        id: 'Large',
        name: 'Large',
      },
      {
        id: 'Extra large',
        name: 'Extra large',
      },
    ],
    label: 'POS font size',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  credit_note_expiry: {
    id: 'preference.setting.credit_note_expiry.title',
    defaultMessage: 'Credit note expiry',
    key: 'credit_note_expiry',
    type: 'Numeric',
    label: 'Credit note expiry',
    category: 'Credit certificate',
    account: true,
    subsidiary: true,
    location: false,
  },

  gift_certificate_expiry: {
    id: 'preference.setting.gift_certificate_expiry.title',
    defaultMessage: 'Gift certificate expiry',
    key: 'gift_certificate_expiry',
    type: 'Numeric',
    label: 'Gift certificate expiry',
    category: 'Credit certificate',
    account: true,
    subsidiary: true,
    location: false,
  },

  customer_credit_expiry: {
    id: 'preference.setting.customer_credit_expiry.title',
    defaultMessage: 'Customer credit expiry',
    key: 'customer_credit_expiry',
    type: 'Numeric',
    label: 'Customer credit expiry',
    category: 'Credit certificate',
    account: true,
    subsidiary: true,
    location: false,
  },

  generate_gift_certificate_id: {
    id: 'preference.setting.generate_gift_certificate_id.title',
    defaultMessage: 'Gift Certificate - Generate certificate id',
    key: 'generate_gift_certificate_id',
    type: 'Boolean',
    label: 'Gift Certificate - Generate certificate id',
    category: 'Credit certificate',
    account: true,
    subsidiary: true,
    location: false,
  },

  enable_gift_certificate_auth_code: {
    id: 'preference.setting.enable_gift_certificate_auth_code.title',
    defaultMessage: 'Gift Certificate - Use authorisation code',
    key: 'enable_gift_certificate_auth_code',
    type: 'Boolean',
    label: 'Gift Certificate - Use authorisation code',
    category: 'Credit certificate',
    account: true,
    subsidiary: true,
    location: false,
  },

  print_gift_certificate_on_receipt: {
    id: 'preference.setting.print_gift_certificate_on_receipt.title',
    defaultMessage: 'Print Gift Certificate',
    key: 'print_gift_certificate_on_receipt',
    type: 'Boolean',
    label: 'Print gift certificate',
    category: 'Credit certificate',
    account: true,
    subsidiary: true,
    location: false,
  },

  print_credit_note_on_receipt: {
    id: 'preference.setting.print_credit_note_on_receipt.title',
    defaultMessage: 'Print Credit Note',
    key: 'print_credit_note_on_receipt',
    type: 'Boolean',
    label: 'Print credit note',
    category: 'Credit certificate',
    account: true,
    subsidiary: true,
    location: false,
  },

  allow_manual_entry: {
    id: 'preference.setting.allow_manual_entry.title',
    defaultMessage: 'Allow manual entry of reference number',
    key: 'allow_manual_entry',
    type: 'Boolean',
    label: 'Allow manual entry of reference number',
    category: 'Credit certificate',
    account: true,
    subsidiary: true,
    location: false,
  },

  allow_return_credit_note: {
    id: 'preference.setting.allow_return_credit_note.title',
    defaultMessage: 'Credit note available on Return',
    key: 'allow_return_credit_note',
    type: 'Boolean',
    label: 'Credit note available on Return',
    // category: "Checkout",
    category: 'Credit certificate',
    account: true,
    subsidiary: true,
    location: false,
  },

  allow_use_by_alternate_entity: {
    id: 'preference.setting.allow_use_by_alternate_entity.title',
    defaultMessage: 'Allow use of credit note by alternate entity',
    key: 'allow_use_by_alternate_entity',
    type: 'Boolean',
    label: 'Allow use of credit note by alternate entity',
    // category: "Checkout",
    category: 'Credit certificate',
    account: true,
    subsidiary: true,
    location: false,
  },

  print_template_giftcertificate: {
    id: 'preference.setting.print_template_gift_certificate.title',
    defaultMessage: 'Gift certificate',
    key: 'print_template_giftcertificate',
    type: 'Object',
    label: 'Gift certificate',
    category: 'Print Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: ['dt:template_type:thermal_print'],
      output_type: ['dt:template_output_type:xml'],
    },
    account: true,
    subsidiary: true,
    location: false,
  },

  print_template_creditnote: {
    id: 'preference.setting.print_template_credit_note.title',
    defaultMessage: 'Credit note',
    key: 'print_template_creditnote',
    type: 'Object',
    label: 'Credit note',
    category: 'Print Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:credit_certificate'],
      template_type: ['dt:template_type:thermal_print'],
      output_type: ['dt:template_output_type:xml'],
    },
    account: true,
    subsidiary: true,
    location: false,
  },

  print_template_giftreceipt: {
    id: 'preference.setting.print_template_gift_receipt.title',
    defaultMessage: 'Gift receipt',
    key: 'print_template_giftreceipt',
    type: 'Object',
    label: 'Gift receipt',
    category: 'Print Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: ['dt:template_type:thermal_print'],
      output_type: ['dt:template_output_type:xml'],
    },
    account: true,
    subsidiary: true,
    location: false,
  },

  enable_payment_with_offline_device: {
    id: 'preference.setting.enable_payment_with_offline_device.title',
    defaultMessage: 'Enable payment with offline device',
    key: 'enable_payment_with_offline_device',
    type: 'Boolean',
    label: 'Enable payment with offline device',
    // category: "Checkout",
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  enable_recent_transaction_filter: {
    id: 'preference.setting.enable_recent_transaction_filter.title',
    defaultMessage: 'Enable recent transactions filter',
    key: 'enable_recent_transaction_filter',
    type: 'Boolean',
    label: 'Enable recent transactions filter',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  quick_customer_reference_entry: {
    id: 'preference.setting.quick_customer_reference_entry.title',
    defaultMessage: "Show transaction's customer reference",
    key: 'quick_customer_reference_entry',
    type: 'Boolean',
    label: "Show transaction's customer reference",
    // category: "Cart",
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  enable_sale_without_payment: {
    id: 'preference.setting.enable_sale_without_payment.title',
    defaultMessage: 'Enable an unpaid transaction to be saved',
    key: 'enable_sale_without_payment',
    type: 'Boolean',
    label: 'Enable an unpaid transaction to be saved',
    // category: "Checkout",
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  print_method: {
    id: 'preference.setting.print_method.title',
    defaultMessage: 'Print method',
    key: 'print_method',
    type: 'Object',
    defined_list: [
      {
        id: 'dt:print_method:pdf',
        name: 'PDF Print',
      },
      {
        id: 'dt:print_method:thermal',
        name: 'Thermal Print',
      },
    ],
    label: 'Print method',
    category: 'Receipt Printing',
    account: true,
    subsidiary: true,
    location: true,
  },

  enable_service_print: {
    id: 'preference.setting.enable_service_print.title',
    defaultMessage: 'Enable service print',
    key: 'enable_service_print',
    type: 'Boolean',
    label: 'Enable service print',
    category: 'Receipt Printing',
    account: true,
    subsidiary: true,
    location: true,
  },

  email_from: {
    id: 'preference.setting.email_from.title',
    defaultMessage: 'Email From',
    key: 'email_from',
    type: 'String',
    label: 'Email from',
    category: 'System Settings',
    account: true,
    subsidiary: true,
    location: true,
  },

  on_checkout_tab: {
    account: true,
    category: 'Register',
    defaultMessage: 'On-Checkout Tab',
    filter: {
      searchParams: {
        type: CustomTabTypes.ON_CHECKOUT,
      },
    },
    id: 'preference.setting.on_checkout_tab.title',
    key: 'on_checkout_tab',
    label: 'On-Checkout Tab',
    list: 'custom_tab',
    location: true,
    subsidiary: true,
    type: 'Object',
  },

  proceed_to_pay_tab: {
    account: true,
    category: 'Register',
    defaultMessage: 'Proceed-To-Pay Tab',
    filter: {
      searchParams: {
        type: CustomTabTypes.PROCEED_TO_PAY,
      },
    },
    id: 'preference.setting.proceed_to_pay_tab.title',
    key: 'proceed_to_pay_tab',
    label: 'Proceed-To-Pay Tab',
    list: 'custom_tab',
    location: true,
    subsidiary: true,
    type: 'Object',
  },

  custom_descriptor_item_cart: {
    account: true,
    category: 'Register',
    defaultMessage: 'Custom descriptor (Item - Cart)',
    id: 'preference.setting.custom_descriptor_item_cart.title',
    key: 'custom_descriptor_item_cart',
    label: 'Custom descriptor (Item - Cart)',
    list: 'custom_form',
    location: true,
    subsidiary: true,
    type: 'Object',
    filter: {
      searchParams: {},
    },
  },

  custom_descriptor_item_search: {
    account: true,
    category: 'Register',
    defaultMessage: 'Custom descriptor (Item - Search)',
    id: 'preference.setting.custom_descriptor_item_search.title',
    key: 'custom_descriptor_item_search',
    label: 'Custom descriptor (Item - Search)',
    list: 'custom_form',
    location: true,
    subsidiary: true,
    type: 'Object',
    filter: {
      searchParams: {},
    },
  },

  enable_workspace_pricing: {
    account: true,
    category: 'Register',
    defaultMessage: 'Enable workspace pricing',
    id: 'preference.setting.enable_workspace_pricing.title',
    key: 'enable_workspace_pricing',
    label: 'Enable workspace pricing',
    location: true,
    subsidiary: true,
    type: 'Boolean',
  },

  enable_tax_exempt: {
    account: true,
    category: 'Register',
    defaultMessage: 'Enable tax exemption',
    id: 'preference.setting.enable_tax_exempt.title',
    key: 'enable_tax_exempt',
    label: 'Enable tax exemption',
    location: true,
    subsidiary: true,
    type: 'Boolean',
  },

  register_access_method: {
    account: true,
    category: 'Register',
    defaultMessage: 'Register access method',
    id: 'preference.setting.register_access_method.title',
    key: 'register_access_method',
    label: 'Register access method',
    location: true,
    subsidiary: true,
    type: 'Object',
    defined_list: [
      {
        id: 'dt:register_access_method:device',
        name: 'Device',
      },
      {
        id: 'dt:register_access_method:location',
        name: 'Location',
      },
      {
        id: 'dt:register_access_method:subsidiary',
        name: 'Subsidiary',
      },
    ],
  },

  open_till_required_to_sell: {
    account: true,
    category: 'Register',
    defaultMessage: 'Disable sales if Cash Drawer is CLOSED',
    id: 'preference.setting.open_till_required_to_sell.title',
    key: 'open_till_required_to_sell',
    label: 'Disable sales if Cash Drawer is CLOSED',
    location: true,
    subsidiary: true,
    type: 'Boolean',
  },

  include_reserve_stock: {
    account: true,
    category: 'Register',
    defaultMessage: 'Include reserve stock',
    id: 'preference.setting.include_reserve_stock.title',
    key: 'include_reserve_stock',
    label: 'Include reserve stock',
    location: false,
    subsidiary: true,
    type: 'Boolean',
  },

  include_location_distance: {
    account: true,
    category: 'Register',
    defaultMessage: 'Include location distance',
    id: 'preference.setting.include_location_distance.title',
    key: 'include_location_distance',
    label: 'Include location distance',
    location: true,
    subsidiary: true,
    type: 'Object',
    defined_list: [
      {
        id: 'dt:include_location_distance:blank',
        name: 'Blank',
      },
      {
        id: 'dt:include_location_distance:km',
        name: 'KM',
      },
      {
        id: 'dt:include_location_distance:miles',
        name: 'Miles',
      },
    ],
  },

  location_sort_order: {
    account: true,
    category: 'Register',
    defaultMessage: 'Location sort order',
    id: 'preference.setting.location_sort_order.title',
    key: 'location_sort_order',
    label: 'Location sort order',
    location: true,
    subsidiary: true,
    type: 'Object',
    defined_list: [
      {
        id: 'dt:location_sort_order:onhand',
        name: 'On-hand',
      },
      {
        id: 'dt:location_sort_order:distance',
        name: 'Distance',
      },
    ],
  },

  app_color: {
    id: 'preference.setting.app_color.title',
    defaultMessage: 'Application Color',
    key: 'app_color',
    type: 'Object',
    defined_list: [
      {
        id: '#00bcd4',
        name: 'Blue Green',
      },
      {
        id: '#2b435a',
        name: 'Blue Grey',
      },
      {
        id: '#1786e8',
        name: 'Blue',
      },
      {
        id: '#27b07c',
        name: 'Green',
      },
      {
        id: '#ff7541',
        name: 'Orange',
      },
      {
        id: '#3f51b5',
        name: 'Purple',
      },
      {
        id: '#f9ca24',
        name: 'Yellow',
      },
    ],
    label: 'Application Color',
    category: 'System Settings',
    subsidiary: true,
    account: true,
  },

  default_entity_loyalty: {
    id: 'preference.setting.default_entity_loyalty.title',
    defaultMessage: 'Default Entity Loyalty',
    key: 'default_entity_loyalty',
    type: 'Boolean',
    label: 'Default Entity Loyalty',
    category: 'System Settings',
    account: true,
    subsidiary: true,
    location: true,
  },

  loyalty_display_default: {
    id: 'preference.setting.loyalty_display_default.title',
    defaultMessage: 'Loyalty display default',
    key: 'loyalty_display_default',
    type: 'Object',
    defined_list: [
      {
        id: 'dt:loyalty_display:points',
        name: 'Points',
      },
      {
        id: 'dt:loyalty_display:payment',
        name: 'Payment',
      },
      {
        id: 'dt:loyalty_display:none',
        name: 'None',
      },
    ],
    label: 'Loyalty display default',
    category: 'Loyalty',
    account: true,
    subsidiary: true,
    location: true,
  },
  loyalty_points_expiry: {
    id: 'preference.setting.loyalty_points_expiry.title',
    defaultMessage: 'Loyalty points expiry',
    key: 'loyalty_points_expiry',
    type: 'Numeric',
    value: 365,
    label: 'Loyalty points expiry',
    category: 'Loyalty',
    account: true,
    subsidiary: true,
    location: true,
  },

  loyalty_calc_on_line_discount: {
    id: 'preference.setting.loyalty_calc_on_line_discount.title',
    defaultMessage: 'Calculate loyalty points when item line discount',
    key: 'loyalty_calc_on_line_discount',
    type: 'Boolean',
    label: 'Calculate loyalty points when item line discount',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  po_auto_refill: {
    id: 'preference.setting.po_auto_refill.title',
    defaultMessage: 'Enable auto-refill',
    key: 'po_auto_refill',
    type: 'Boolean',
    label: 'Enable auto-refill',
    category: 'Item Management',
    account: true,
    subsidiary: true,
    location: true,
  },
  po_auto_refill_lines: {
    id: 'preference.setting.po_auto_refill_lines.title',
    defaultMessage: 'Auto refill max lines',
    key: 'po_auto_refill_lines',
    type: 'Numeric',
    value: 10,
    label: 'Auto refill max lines',
    category: 'Item Management',
    account: true,
    subsidiary: true,
    location: true,
  },
  po_line_unit_cost: {
    id: 'preference.setting.po_line_unit_cost.title',
    defaultMessage: 'Purchase order - default unit cost',
    key: 'po_line_unit_cost',
    type: 'Object',
    defined_list: [
      {
        id: 'dt:line_unit_cost:purchase_cost',
        name: 'Purchase cost',
      },
      {
        id: 'dt:line_unit_cost:average_cost',
        name: 'Average cost',
      },
    ],
    label: 'Purchase order - default unit cost',
    category: 'Item Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  process_external_sale_inventory: {
    id: 'preference.setting.process_external_sale_inventory.title',
    defaultMessage: 'Process external sale inventory',
    key: 'process_external_sale_inventory',
    type: 'Boolean',
    label: 'Process external sale inventory',
    category: 'Item Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  enable_full_menu_options: {
    id: 'preference.setting.enable_full_menu_options.title',
    defaultMessage: 'Enable full menu options',
    key: 'enable_full_menu_options',
    type: 'Boolean',
    label: 'Enable full menu options',
    category: 'System Settings',
    account: true,
    subsidiary: true,
    location: true,
  },
  enable_till_top_up: {
    id: 'preference.setting.enable_till_top_up.title',
    defaultMessage: 'Enable till top up',
    key: 'enable_till_top_up',
    type: 'Boolean',
    label: 'Enable till top up',
    category: 'Till Management',
    account: true,
    subsidiary: true,
    location: true,
  },
  enable_petty_cash: {
    id: 'preference.setting.enable_petty_cash.title',
    defaultMessage: 'Enable petty cash',
    key: 'enable_petty_cash',
    type: 'Boolean',
    label: 'Enable petty cash',
    category: 'Till Management',
    account: true,
    subsidiary: true,
    location: true,
  },
  enable_envelop_drop: {
    id: 'preference.setting.enable_envelop_drop.title',
    defaultMessage: 'Enable envelop drop',
    key: 'enable_envelop_drop',
    type: 'Boolean',
    label: 'Enable envelop drop',
    category: 'Till Management',
    account: true,
    subsidiary: true,
    location: true,
  },
  enable_bank_drop: {
    id: 'preference.setting.enable_bank_drop.title',
    defaultMessage: 'Enable bank drop',
    key: 'enable_bank_drop',
    type: 'Boolean',
    label: 'Enable bank drop',
    category: 'Till Management',
    account: true,
    subsidiary: true,
    location: true,
  },
  enable_till_sweep: {
    id: 'preference.setting.enable_till_sweep.title',
    defaultMessage: 'Enable till sweep',
    key: 'enable_till_sweep',
    type: 'Boolean',
    label: 'Enable till sweep',
    category: 'Till Management',
    account: true,
    subsidiary: true,
    location: true,
  },
  enable_low_quantity_receipt: {
    id: 'preference.setting.enable_low_quantity_receipt.title',
    defaultMessage: 'Enable PO receipt to negative quantity',
    key: 'enable_low_quantity_receipt',
    type: 'Boolean',
    label: 'Enable PO receipt to negative quantity',
    category: 'Item Management',
    account: true,
    subsidiary: true,
    location: true,
  },
  shipping_integrator: {
    id: 'preference.setting.shipping_integrator.title',
    defaultMessage: 'Shipping integrator',
    key: 'shipping_integrator',
    type: 'Object',
    label: 'Shipping integrator',
    category: 'Order Management',
    list: 'integration',
    filter: {
      type_id: ['dt:integration_type:shippit'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },

  /** Start of Order Management Preference */

  oms_timeout_reason_code: {
    id: 'preference.setting.oms_timeout_reason_code.title',
    defaultMessage: 'Default timeout reason code',
    key: 'oms_timeout_reason_code',
    type: 'Object',
    list: 'reason_code',
    label: 'Default timeout reason code',
    category: 'Order Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_reallocate_reason_code: {
    id: 'preference.setting.oms_reallocate_reason_code.title',
    defaultMessage: 'Default reallocate/reject reason code',
    key: 'oms_reallocate_reason_code',
    type: 'Object',
    list: 'reason_code',
    label: 'Default reallocate/reject reason code',
    category: 'Order Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_default_delivery_type: {
    id: 'preference.setting.oms_default_delivery_type.title',
    defaultMessage: 'Default OMS delivery type',
    key: 'oms_default_delivery_type',
    type: 'Object',
    list: 'delivery_type',
    label: 'Default OMS delivery type',
    category: 'Order Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_sale_closed_reason_code: {
    id: 'preference.setting.oms_sale_closed_reason_code.title',
    defaultMessage: 'Abandoned - Sale CLOSED',
    key: 'oms_sale_closed_reason_code',
    type: 'Object',
    list: 'reason_code',
    label: 'Abandoned - Sale CLOSED',
    category: 'Order Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_sale_altered_reason_code: {
    id: 'preference.setting.oms_sale_altered_reason_code.title',
    defaultMessage: 'Abandoned - Sale Altered',
    key: 'oms_sale_altered_reason_code',
    type: 'Object',
    list: 'reason_code',
    label: 'Abandoned - Sale Altered',
    category: 'Order Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_wave_by_order: {
    id: 'preference.setting.oms_wave_by_order.title',
    defaultMessage: 'Wave by Order',
    key: 'oms_wave_by_order',
    type: 'Boolean',
    label: 'Wave by Order',
    category: 'Order Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_alert_packed: {
    id: 'preference.setting.oms_alert_packed.title',
    defaultMessage: 'Alert - Packed',
    key: 'oms_alert_packed',
    type: 'Object',
    label: 'Alert - Packed',
    defined_list: [
      {
        id: '#edffed',
        name: 'Light Green',
      },
      {
        id: '#a3ffa3',
        name: 'Dark Green',
      },
    ],
    category: 'Order Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_alert_picked: {
    id: 'preference.setting.oms_alert_picked.title',
    defaultMessage: 'Alert - Picked',
    key: 'oms_alert_picked',
    type: 'Object',
    label: 'Alert - Picked',
    defined_list: [
      {
        id: '#fff8ed',
        name: 'Light Yellow',
      },
      {
        id: '#ffb747',
        name: 'Dark Yellow',
      },
    ],
    category: 'Order Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_alert_pending: {
    id: 'preference.setting.oms_alert_pending.title',
    defaultMessage: 'Alert - Pending',
    key: 'oms_alert_pending',
    type: 'Object',
    defined_list: [
      {
        id: '#ffeded',
        name: 'Light Red',
      },
      {
        id: '#ffb6b6',
        name: 'Dark Red',
      },
    ],
    label: 'Alert - Pending',
    category: 'Order Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_use_pick: {
    id: 'preference.setting.oms_use_pick.title',
    defaultMessage: 'Use Status Pick',
    key: 'oms_use_pick',
    type: 'Boolean',
    label: 'Use Status Pick',
    category: 'Order Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_use_pack: {
    id: 'preference.setting.oms_use_pack.title',
    defaultMessage: 'Use Status Pack',
    key: 'oms_use_pack',
    type: 'Boolean',
    label: 'Use Status Pack',
    category: 'Order Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_pick_by_order: {
    id: 'preference.setting.oms_pick_by_order.title',
    defaultMessage: 'Pick by Order',
    key: 'oms_pick_by_order',
    type: 'Boolean',
    label: 'Pick by Order',
    category: 'Order Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_combine_pick_pack: {
    id: 'preference.setting.oms_combine_pick_pack.title',
    defaultMessage: 'Combine Pick and Pack',
    key: 'oms_combine_pick_pack',
    type: 'Boolean',
    label: 'Combine Pick and Pack',
    category: 'Order Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_hide_row_actions: {
    id: 'preference.setting.oms_hide_row_actions.title',
    defaultMessage: 'Hide row actions',
    key: 'oms_hide_row_actions',
    type: 'Boolean',
    label: 'Hide row actions',
    category: 'Order Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_update_ship_sale_rep: {
    id: 'preference.setting.oms_update_ship_sale_rep.title',
    defaultMessage: 'Update Ship to Customer Sale Rep',
    key: 'oms_update_ship_sale_rep',
    type: 'Boolean',
    label: 'Update Ship to Customer Sale Rep',
    category: 'Order Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_update_pickup_sale_rep: {
    id: 'preference.setting.oms_update_pickup_sale_rep.title',
    defaultMessage: 'Update Pick-up in Store Sale Rep',
    key: 'oms_update_pickup_sale_rep',
    type: 'Boolean',
    label: 'Update Pick-up in Store Sale Rep',
    category: 'Order Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_close_order_without_shipper: {
    id: 'preference.setting.oms_close_order_without_shipper.title',
    defaultMessage: 'Close order without shipper',
    key: 'oms_close_order_without_shipper',
    type: 'Boolean',
    label: 'Close order without shipper',
    category: 'Order Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_print_all_ship: {
    id: 'preference.setting.oms_print_all_ship.title',
    defaultMessage: 'Print label - print all (shipping)',
    key: 'oms_print_all_ship',
    type: 'Boolean',
    label: 'Print label - print all (shipping)',
    category: 'Order Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_print_all_pickup: {
    id: 'preference.setting.oms_print_all_pickup.title',
    defaultMessage: 'Print label - print all (pickup)',
    key: 'oms_print_all_pickup',
    type: 'Boolean',
    label: 'Print label - print all (pickup)',
    category: 'Order Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  shortcuts: {
    id: 'preference.setting.shortcuts.title',
    defaultMessage: 'Shortcuts',
    key: 'shortcuts',
    type: 'Object',
    label: 'Shortcuts',
    category: 'System Settings',
    list: 'shortcut_group',
    account: true,
    subsidiary: true,
    location: true,
  },

  shortcuts_pos: {
    id: 'preference.setting.shortcuts_register.title',
    defaultMessage: 'Shortcuts (Register)',
    key: 'shortcuts_pos',
    type: 'Object',
    label: 'Shortcuts (Register)',
    category: 'Register',
    list: 'shortcut_group',
    account: true,
    subsidiary: true,
    location: true,
  },

  entity_email_unique: {
    id: 'preference.setting.entity_email_unique.title',
    defaultMessage: 'Entity Email Unique',
    key: 'entity_email_unique',
    type: 'Object',
    defined_list: [
      {
        id: 'WARNING',
        name: 'WARNING',
      },
      {
        id: 'ERROR',
        name: 'ERROR',
      },
      {
        id: 'NULL',
        name: 'NULL',
      },
    ],
    label: 'Entity Email Unique',
    category: 'System Settings',
    account: true,
    subsidiary: true,
    location: true,
  },

  entity_contact_number_unique: {
    id: 'preference.setting.entity_contact_number_unique.title',
    defaultMessage: 'Entity Contact Number Unique',
    key: 'entity_contact_number_unique',
    type: 'Object',
    defined_list: [
      {
        id: 'WARNING',
        name: 'WARNING',
      },
      {
        id: 'ERROR',
        name: 'ERROR',
      },
      {
        id: 'NULL',
        name: 'NULL',
      },
    ],
    label: 'Entity Contact Number Unique',
    category: 'System Settings',
    account: true,
    subsidiary: true,
    location: true,
  },

  entity_email_or_contact_required: {
    id: 'preference.setting.entity_email_or_contact_required.title',
    defaultMessage: 'Entity Email or Contact Number Required',
    key: 'entity_email_or_contact_required',
    type: 'Boolean',
    label: 'Entity Email or Contact Number Required',
    category: 'System Settings',
    account: true,
    subsidiary: true,
    location: true,
  },

  netsuite_integration: {
    id: 'preference.setting.netsuite_integration.title',
    defaultMessage: 'Netsuite integration',
    key: 'netsuite_integration',
    type: 'Object',
    label: 'Netsuite integration',
    category: 'System Settings',
    list: 'integration',
    filter: {
      type_id: ['dt:integration_type:netsuite'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },

  complete_paid_sale: {
    id: 'preference.setting.complete_paid_sale.title',
    defaultMessage: 'Complete sale on payment (Seconds)',
    key: 'complete_paid_sale',
    type: 'Numeric',
    label: 'Complete sale on payment (Seconds)',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  auto_print_receipt: {
    id: 'preference.setting.auto_print_receipt.title',
    defaultMessage: 'Auto print receipt',
    key: 'auto_print_receipt',
    type: 'Numeric',
    label: 'Auto print receipt',
    category: 'Receipt Printing',
    account: true,
    subsidiary: true,
    location: true,
  },

  auto_print_service_receipt: {
    id: 'preference.setting.auto_print_service_receipt.title',
    defaultMessage: 'Auto print service receipt',
    key: 'auto_print_service_receipt',
    type: 'Boolean',
    label: 'Auto print service receipt',
    category: 'Receipt Printing',
    account: true,
    subsidiary: true,
    location: true,
  },

  default_receipt_type: {
    id: 'preference.setting.default_receipt_type.title',
    defaultMessage: 'Default receipt type',
    key: 'default_receipt_type',
    type: 'Object',
    defined_list: [
      {
        id: 'print',
        name: 'Print',
      },
      {
        id: 'email',
        name: 'Email',
      },
      {
        id: 'ereceipt',
        name: 'Mobile',
      },
      {
        id: 'gift',
        name: 'Gift',
      },
      {
        id: 'service',
        name: 'Service',
      },
    ],
    label: 'Default receipt type',
    category: 'Receipt Printing',
    account: true,
    subsidiary: true,
    location: true,
  },

  enable_receipt_print: {
    id: 'preference.setting.enable_receipt_print.title',
    defaultMessage: 'Enable receipt print',
    key: 'enable_receipt_print',
    type: 'Boolean',
    label: 'Enable receipt print',
    category: 'Receipt Printing',
    account: true,
    subsidiary: true,
    location: true,
  },

  enable_gift_receipt_print: {
    id: 'preference.setting.enable_gift_print.title',
    defaultMessage: 'Enable gift receipt print',
    key: 'enable_gift_print',
    type: 'Boolean',
    label: 'Enable gift receipt print',
    category: 'Receipt Printing',
    account: true,
    subsidiary: true,
    location: true,
  },

  enable_email_receipt: {
    id: 'preference.setting.enable_email_receipt.title',
    defaultMessage: 'Enable email receipt',
    key: 'enable_email_receipt',
    type: 'Boolean',
    label: 'Enable email receipt',
    category: 'Receipt Printing',
    account: true,
    subsidiary: true,
    location: true,
  },

  enable_item_image_search: {
    id: 'preference.setting.enable_item_image_search.title',
    defaultMessage: 'Render item image on search list',
    key: 'enable_item_image_search',
    type: 'Boolean',
    label: 'Render item image on search list',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  enable_no_receipt: {
    id: 'preference.setting.enable_no_receipt.title',
    defaultMessage: 'Enable No Receipt',
    key: 'enable_no_receipt',
    type: 'Boolean',
    label: 'Enable No Receipt',
    category: 'Receipt Printing',
    account: true,
    subsidiary: true,
    location: true,
  },

  enable_printing_options: {
    id: 'preference.setting.enable_printing_options.title',
    defaultMessage: 'Enable printing options',
    key: 'enable_printing_options',
    type: 'Object',
    defined_list: [
      {
        id: 'no_payment',
        name: 'No payment',
      },
      {
        id: 'partial_payment',
        name: 'Partial payment',
      },
      {
        id: 'full_payment',
        name: 'Full payment',
      },
    ],
    label: 'Enable printing options',
    category: 'Receipt Printing',
    account: true,
    subsidiary: true,
    location: true,
  },

  pop_cash_drawer_only_on_complete: {
    id: 'preference.setting.pop_cash_drawer_only_on_complete.title',
    defaultMessage: 'Pop drawer at sale end',
    key: 'pop_cash_drawer_only_on_complete',
    type: 'Boolean',
    label: 'Pop drawer at sale end',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  enable_park_sales: {
    id: 'preference.setting.enable_park_sales.title',
    defaultMessage: 'Enable park sales',
    key: 'enable_park_sales',
    type: 'Boolean',
    label: 'Enable park sales',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  display_item_number: {
    id: 'preference.setting.display_item_number.title',
    defaultMessage: 'Display item number',
    key: 'display_item_number',
    type: 'Boolean',
    label: 'Display item number',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  lock_sales_rep: {
    id: 'preference.setting.lock_sales_rep.title',
    defaultMessage: 'Lock sales representative',
    key: 'lock_sales_rep',
    type: 'Boolean',
    label: 'Lock sales representative',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  lock_fully_paid_sales: {
    id: 'preference.setting.lock_fully_paid_sales.title',
    defaultMessage: 'Lock fully paid sales',
    key: 'lock_fully_paid_sales',
    type: 'Boolean',
    label: 'Lock fully paid sales',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  enable_validated_return_discount: {
    id: 'preference.setting.enable_validated_return_discount.title',
    defaultMessage: 'Enable validated return discount',
    key: 'enable_validated_return_discount',
    type: 'Boolean',
    label: 'Enable validated return discount',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  disable_cart_void: {
    id: 'preference.setting.disable_cart_void.title',
    defaultMessage: 'Disable cart void',
    key: 'disable_cart_void',
    type: 'Boolean',
    label: 'Disable cart void',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  sms_template_sale_ereceipt_link: {
    id: 'preference.setting.sms_template_sale_ereceipt_link.title',
    defaultMessage: 'SMS template (Sale - Mobile - Link)',
    key: 'sms_template_sale_ereceipt_link',
    type: 'Object',
    label: 'SMS template (Sale - Mobile - Link)',
    category: 'SMS Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: ['dt:template_type:sms'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },

  sms_template_sale_ereceipt_code: {
    id: 'preference.setting.sms_template_sale_ereceipt_code.title',
    defaultMessage: 'SMS template (Sale - Mobile - Code)',
    key: 'sms_template_sale_ereceipt_code',
    type: 'Object',
    label: 'SMS template (Sale - Mobile - Code)',
    category: 'SMS Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:sale'],
      template_type: ['dt:template_type:sms'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },

  payment_types_font_size: {
    id: 'preference.setting.payment_types_font_size.title',
    defaultMessage: 'Payment types font size',
    key: 'payment_types_font_size',
    type: 'Object',
    defined_list: [
      {
        id: 'regular',
        name: 'Regular',
      },
      {
        id: 'medium',
        name: 'Medium',
      },
      {
        id: 'large',
        name: 'Large',
      },
      {
        id: 'xlarge',
        name: 'Extra large',
      },
    ],
    label: 'Payment types font size',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  login_popup_reminder_register: {
    id: 'preference.setting.login_popup_reminder_register.title',
    defaultMessage: 'Login popup reminder (Register)',
    key: 'login_popup_reminder_register',
    type: 'Object',
    label: 'Login popup reminder (Register)',
    category: 'Register',
    list: 'shortcut',
    account: true,
    subsidiary: true,
    location: true,
  },

  display_only_receipt_options_complete_paid_sale: {
    id: 'preference.setting.display_only_receipt_options_complete_paid_sale.title',
    defaultMessage: 'Show only receipt options for fully paid sales',
    key: 'display_only_receipt_options_complete_paid_sale',
    type: 'Boolean',
    label: 'Show only receipt options for fully paid sales',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  background_sync_delay: {
    id: 'preference.setting.background_sync_delay.title',
    defaultMessage: 'Background sync delay (minutes)',
    key: 'background_sync_delay',
    type: 'Numeric',
    value: 5,
    label: 'Background sync delay (minutes)',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  disable_lock_register_on_incorrect_pin: {
    id: 'preference.setting.disable_lock_register_on_incorrect_pin.title',
    defaultMessage: 'Disable lock register on incorrect pin',
    key: 'disable_lock_register_on_incorrect_pin',
    type: 'Boolean',
    label: 'Disable lock register on incorrect pin',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  available_storage_threshold: {
    id: 'preference.setting.available_storage_threshold.title',
    defaultMessage: 'Available storage threshold (%)',
    key: 'available_storage_threshold',
    type: 'Numeric',
    value: 50,
    label: 'Available storage threshold (%)',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  default_return_to_shelf: {
    id: 'preference.setting.default_return_to_shelf.title',
    defaultMessage: 'Default return to shelf',
    key: 'default_return_to_shelf',
    type: 'Boolean',
    value: false,
    label: 'Default return to shelf',
    category: 'Register',
    account: true,
    subsidiary: true,
    location: true,
  },

  validated_reason_code_required: {
    id: 'preference.setting.validated_reason_code_required.title',
    defaultMessage: 'Validated reason code required',
    key: 'validated_reason_code_required',
    type: 'Boolean',
    label: 'Validated reason code required',
    category: 'Register',
    value: true,
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_send_pack_sms_pickup: {
    id: 'preference.setting.oms_send_pack_sms_pickup.title',
    defaultMessage: 'SMS Customer - Packed (Pickup)',
    key: 'oms_send_pack_sms_pickup',
    type: 'Boolean',
    label: 'SMS Customer - Packed (Pickup)',
    category: 'Order Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_default_ignore_location_find: {
    id: 'preference.setting.oms_default_ignore_location_find.title',
    defaultMessage: 'Default OMS Ignore Location Find',
    key: 'oms_default_ignore_location_find',
    type: 'Boolean',
    label: 'Default OMS Ignore Location Find',
    category: 'Order Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_sms_customer_packed_pickup: {
    id: 'preference.setting.oms_sms_customer_packed_pickup.title',
    defaultMessage: 'OMS SMS Customer - Packed',
    key: 'oms_sms_customer_packed_pickup',
    type: 'Object',
    label: 'OMS SMS Customer - Packed (Pickup)',
    category: 'SMS Templates',
    list: 'print_template',
    filter: {
      apply_to: ['dt:apply_template:oms:order'],
      template_type: ['dt:template_type:sms'],
    },
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_use_shipping_integrator_pack_list: {
    id: 'preference.setting.oms_use_shipping_integrator_pack_list.title',
    defaultMessage: 'Shipping integrator - Use pack list',
    key: 'oms_use_shipping_integrator_pack_list',
    type: 'Boolean',
    label: 'Shipping integrator - Use pack list',
    category: 'Order Management',
    account: true,
    subsidiary: true,
    location: true,
  },

  oms_use_shipping_integrator_label: {
    id: 'preference.setting.oms_use_shipping_integrator_label.title',
    defaultMessage: 'Shipping integrator - Use label',
    key: 'oms_use_shipping_integrator_label',
    type: 'Boolean',
    label: 'Shipping integrator - Use label',
    category: 'Order Management',
    account: true,
    subsidiary: true,
    location: true,
  },
});
